import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { TaskSurvey, TaskView } from 'components/platform'

import { getTaskAction } from 'store/taskManager/actions'
import { useHasUserTag } from '@centra/centra-ui/dist'
import { TaskListContainer, TaskListSidebar } from 'components/TaskListSidebar/TaskListSidebar'

import styles from './Task.module.scss'

const Task = () => {
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const history = useHistory()
  const isCentraManager = useHasUserTag(['role.account-manager', 'role.admin', 'role.supervisor'])
  const isClientUser = useHasUserTag(['customerUser'])

  isCentraManager && history.push(`/?task=${id}`)

  useEffect(() => {
    return () => {
      dispatch(getTaskAction({ id }))
    }
  }, [id])

  return (
    <TaskListContainer className={styles.root}>
      <TaskView />
      <TaskListSidebar />
      {isClientUser && <TaskSurvey />}
    </TaskListContainer>
  )
}

export default Task
